import { render } from "./fidelio.vue?vue&type=template&id=4a92dde0"
import script from "./fidelio.vue?vue&type=script&lang=js"
export * from "./fidelio.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__